import { View } from 'react-native';

import React, { createContext, ReactNode, useContext } from 'react';
import { twMerge } from 'tailwind-merge';

export const getListItemPosition = (index: number, length: number) => {
  if (length == 1) {
    return 'full';
  } else if (index === 0) {
    return 'top';
  } else if (index === length - 1) {
    return 'bottom';
  } else {
    return 'middle';
  }
};

export function useListItemPosition() {
  const context = useContext(ListContext);
  if (context == null) return 'middle';

  return getListItemPosition(context.index, context.count);
}

export const ListContext = createContext<{
  index: number;
  count: number;
} | null>(null);

const ListContainer = ({
  className,
  children,
}: {
  className?: string;
  children: ReactNode;
}) => {
  const count = React.Children.count(children);

  const itemsWithPosition = React.Children.map(children, (child, index) => {
    if (!React.isValidElement(child)) return null;

    return (
      <ListContext.Provider
        value={{
          index,
          count,
        }}
      >
        <View className="w-full pb-0.5">{child}</View>
      </ListContext.Provider>
    );
  });

  return (
    <View
      className={twMerge('flex flex-column items-center w-full', className)}
    >
      {itemsWithPosition}
    </View>
  );
};

export default ListContainer;
